import { component } from 'common/util/ComponentDecorator';

@component
export default class Page {
	static classname = 'page';

	constructor($page) {
		this.$page = $page;
	}
}
